// Implied Price Check — emergent feature (E1). Results screen.
// Only relevant for direct / tender / DCF equity-value valuations (backsolve
// makes the check tautological). The selector hides this component otherwise.

import type { ImpliedPriceRow } from '@backsolve/shared-logic/impliedPriceCheck';
import { usdPrecise, pct } from '../../format/format';
import { Tooltip } from '../common/Tooltip';

interface ImpliedPriceCheckProps {
  rows: ImpliedPriceRow[];
}

export function ImpliedPriceCheck({ rows }: ImpliedPriceCheckProps) {
  if (rows.length === 0) return null;
  return (
    <div className="card">
      <div className="card-title">
        Implied Price Check
        <Tooltip
          label="Compares each preferred class's original issue price against the per-share value implied by allocating the total equity value across the waterfall. Large deltas (|Δ| > 25%) may indicate an inconsistent equity-value assumption."
          ariaLabel="Help: Implied Price Check"
        />
      </div>
      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>Class</th>
              <th>Issue Date</th>
              <th>Issue $</th>
              <th>Implied $</th>
              <th>Δ%</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.instrumentId} className={Math.abs(r.deltaPct) > 0.25 ? 'row-flagged' : ''}>
                <td>{r.name}</td>
                <td>{r.issueDate ?? '—'}</td>
                <td>{usdPrecise(r.issuePrice)}</td>
                <td>{usdPrecise(r.impliedPerShare)}</td>
                <td className={Math.abs(r.deltaPct) > 0.25 ? 'badge-warning' : ''}>
                  {pct(r.deltaPct, 1)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
